/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import styled from '@emotion/styled';
import MuiDialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
const StyledModalBody = styled(Grid, {
    shouldForwardProp: prop => prop !== 'shouldHideScroll'
}) `
	width: 100%;
	height: 100%;
	${(props) => !props.shouldHideScroll && 'overflow-y: auto'};
`;
export const Modal = props => {
    const DialogStyles = css `
		width: 100%;
		.MuiDialog-paper {
			${props.maxHeight && 'height: 100%'};
			${props.minHeight && 'min-height: ' + props.minHeight + 'px'};
			width: ${props.width ? props.width + 'px' : '100%'};
			${props.shouldHideScroll && 'overflow-y: visible'};
			${props.customHeight && !props.maxHeight && 'height: ' + props.customHeight + '%'}
		}
		.MuiDialog-scrollBody {
			display: 'flex';
			align-items: 'center';
		}
	`;
    const { classes = {} } = props;
    return (jsx(MuiDialog, { classes: { paper: classes.muiDialogPaper }, open: props.isOpen, onClose: props.onClose, maxWidth: props.maxWidth, scroll: props.scroll, disableBackdropClick: true, disableEscapeKeyDown: props.disableEscapeKeyDown, className: props.className, css: DialogStyles, id: props.id },
        !props.shouldHideHeaderAndFooter && (jsx(ModalHeader, { title: props.title, hideClose: props.hideClose, isLightbox: props.isLightbox, onClose: props.onClose, classes: {
                header: classes.header,
                headerLightbox: classes.headerLightbox,
                headerCloseButton: classes.headerCloseButton
            } })),
        jsx(StyledModalBody, { container: true, direction: "row", justify: "flex-start", alignItems: "stretch", wrap: "nowrap", id: props.id && `${props.id}-modal-body`, shouldHideScroll: !!props.shouldHideScroll }, props.children),
        props.customModalFooter
            ? props.customModalFooter
            : !props.shouldHideHeaderAndFooter && (jsx(ModalFooter, { isLightbox: props.isLightbox, primaryBtn: props.primaryBtn, secondaryBtn: props.secondaryBtn, tertiaryBtn: props.tertiaryBtn, additionalButtons: props.additionalButtons, classes: {
                    footer: classes.footer,
                    footerLightbox: classes.footerLightbox
                } }))));
};
Modal.defaultProps = {
    title: '',
    isLightbox: false,
    hideClose: false
};
//# sourceMappingURL=Modal.js.map